import DailyLoadsRequests from '../../server/dailyLoadCarriers';
import { addLoading, removeLoading } from './loading';

export const getDailyLoadCarriers = (position, branchCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const dailyLoadCarriers = await DailyLoadsRequests.getDailyLoadCarriers(position, branchCode);
    return dailyLoadCarriers;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCarriersDailyLoad = (carrierCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const carriers = await DailyLoadsRequests.getCarriersDailyLoad(carrierCode);
    return carriers;
  } finally {
    dispatch(removeLoading());
  }
};

export const searchCarriers = (searchParams) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const carriers = await DailyLoadsRequests.searchCarriers(searchParams);
    return carriers;
  } finally {
    dispatch(removeLoading());
  }
};

export const linkDailyLoadCarrier = (carrierId, dailyLoadId, position, branchCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await DailyLoadsRequests.linkDailyLoadCarrier(
      carrierId,
      dailyLoadId,
      position,
      branchCode,
    );
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const unlinkDailyLoadCarrier = (dailyLoadCarrierId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await DailyLoadsRequests.unlinkDailyLoadCarrier(dailyLoadCarrierId);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
